import styled from '@emotion/styled';

import theme from 'styles/theme';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 16px;

  @media (min-width: 769px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    padding: 20px 24px 16px;
  }
`;

export const SearchFieldWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SearchHint = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.3;
  color: ${theme.colors.mediumGray};
`;
